import { useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IQuestion } from 'cat-shared/utils'
import { AppChip, AppDivider, AppHeader, AppParagraph } from 'client/ui-building-blocks'
import { UserAvatar } from 'client/components'
import { humanizeFromToNow } from 'client/services'
import { useGetQuestionCategories } from 'client/api'

import styles from './question-list-item.module.scss'

type Props = {
  activePage: number
  item: IQuestion
  isFetching: boolean
  onItemClick: () => void
}

const QuestionListItem = (props: Props) => {
  const { t, i18n } = useTranslation()

  const [displayCreatedAtInfo, setDisplayCreatedAtInfo] = useState<boolean>(true)

  const { data: questionCategories } = useGetQuestionCategories({})

  const { item, onItemClick } = props

  useLayoutEffect(() => {
    if (!props.isFetching) {
      setDisplayCreatedAtInfo(!item.requestorAnsweredAt)
    }
  }, [props.isFetching])

  return (
    <div className={styles.item} onClick={onItemClick}>
      <div>
        <div>
          <div>
            {questionCategories ? (
              <>
                <AppChip
                  key={item.category}
                  variant="success"
                  text={
                    questionCategories[i18n.language.toLowerCase()].find(
                      c => c.key === item.category
                    ).text
                  }
                />
                <AppDivider size="xsmall" />
              </>
            ) : null}
            <AppHeader data-testid="title" text={item.text} />
          </div>
          <div>
            <UserAvatar
              userId={item.creatorId.toString()}
              size="small"
              rounded
              hideIfAdmin
            />
          </div>
        </div>
        <div>
          {item.submittedTimes ? (
            <AppParagraph
              text={t('question.info.submittedTimes', {
                count: item.submittedTimes,
              })}
              color="secondary"
              size="small"
            />
          ) : null}
          {displayCreatedAtInfo && (
            <AppParagraph
              text={t('question.info.creationTimePassed', {
                timePassed: humanizeFromToNow(item.createdAt, i18n.language),
              })}
              color="secondary"
              size="small"
            />
          )}
          {item.requestorAnsweredAt ? (
            <AppParagraph
              text={t('question.info.submissionTimePassed', {
                timePassed: humanizeFromToNow(item.requestorAnsweredAt, i18n.language),
              })}
              color="secondary"
              size="small"
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default QuestionListItem
